import { render, staticRenderFns } from "./RestaurantsLeisuresComponent.vue?vue&type=template&id=a3299bd4&scoped=true"
import script from "./RestaurantsLeisuresComponent.vue?vue&type=script&lang=js"
export * from "./RestaurantsLeisuresComponent.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsLeisuresComponent.vue?vue&type=style&index=0&id=a3299bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3299bd4",
  null
  
)

export default component.exports